import React from 'react'

const MomentModalLoading = ({
  title,
  values,
  handleChange,
  handleBlur,
  isSubmitting,
}) => (
  <div className="modal is-active">
    <div className="modal-background" />

    <div className="modal-card">
      <section className="modal-card-body">
        <h4 className="title is-4">LOADING</h4>
        <p className="subtitle">Please wait...</p>
      </section>
    </div>
  </div>
)

export default MomentModalLoading



// WEBPACK FOOTER //
// ./src/components/templates/momentCard/MomentModalLoading.js